export default __webpack_public_path__ + "static/media/phone-call.b76498e5.png";